import { Actions, ActionTypes } from './actions';
import { CheckoutConfig } from '../../types/checkout';
import { SessionResponse } from './types';
import { SalesLocation } from '../../types/customers';
import { Account } from '../../types/management-auth';

export interface State {
    isLoading: boolean;
    error: boolean;
    createdSession?: SessionResponse;
    checkoutConfig?: CheckoutConfig;
    locations: SalesLocation[];
    account?: Account;
}

export const initialState: State = {
    isLoading: false,
    error: false,
    createdSession: undefined,
    checkoutConfig: undefined,
    locations: [],
    account: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.FetchTerminalData:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.FetchTerminalDataResponse:
            return {
                ...state,
                isLoading: false,
                error: false,
                checkoutConfig: action.payload.config,
                locations: action.payload.locations,
                account: action.payload.account,
            };

        case ActionTypes.CreateCheckoutSession:
            return {
                ...state,
                isLoading: true,
            };

        case ActionTypes.CreateCheckoutSessionResponse:
            return {
                ...state,
                isLoading: false,
                createdSession: action.payload.sessionResponse,
                error: false,
            };

        case ActionTypes.ClearData:
            return initialState;

        default:
            return state;
    }
}
